import {Component, Input, OnInit} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {AnnotationListComponent} from '@app/annotation/annotation-list/annotation-list.component';
import {Asset} from '@app/asset';

@Component({
    selector: 'frog-annotation-inspector',
    templateUrl: './annotation-inspector.component.html',
    styleUrls: ['./annotation-inspector.component.scss'],
    imports: [MatIcon, AnnotationListComponent],
})
export class AnnotationInspectorComponent implements OnInit {
    @Input() asset: Asset;

    constructor() {}

    ngOnInit(): void {}
}
